import "flowbite";

import "../css/index.css";
import "../css/fonts.css";
import "../css/case-study-list.css";
import "../css/content.css";
import "../css/enquiry.css";
import "../css/directory.css";
import "../css/directory-detail.css";
import "../css/data-object-dependents-table.css";

import CaseStudySearch from "./CaseStudySearch.js";
import Directory from "./Directory.js";
import DataObjectDependentsTable from "./DataObjectDependentsTable.js";

function kitmapInit() {
    // Back to search buttons use the last saved state of the search
    let buttons = document.querySelectorAll(".button-back-to-search");
    for (let button of buttons) {
        button.addEventListener("click", function (event) {
            let hash = sessionStorage.getItem("latestDirectoryHash");
            let directoryLink = button.getAttribute("href");
            if (hash) {
                event.preventDefault();
                window.location = directoryLink + hash;
            }
        });
    }

    // Case Study List Search
    let caseStudyListContainer = document.getElementById(
        "kitmap-case-study-list"
    );
    if (caseStudyListContainer) {
        const caseStudyList = new CaseStudySearch(caseStudyListContainer);
    }

    // Directory Search Page
    let directoryContainer = document.getElementById("kitmap-directory");
    if (directoryContainer) {
        const directory = new Directory(directoryContainer);
    }

    // Directory Detail Pages have Tabs - one tab has a fancy table
    let dependentTableContainers = document.querySelectorAll(
        ".data-object-dependents-table"
    );
    let dependentTables = [];
    for (let i = 0; i < dependentTableContainers.length; i++) {
        dependentTables.push(
            new DataObjectDependentsTable(dependentTableContainers[i], i)
        );
    }
    let tabsContainer = document.getElementById("detail-page-tabs");
    if (tabsContainer) {
        let tabs = tabsContainer.querySelectorAll(".tab");
        window.detailPageTabChangeTo = function (id) {
            for (let i = 0; i < tabs.length; i++) {
                let tab = tabs[i];
                let active =
                    (id === "" && i === 0) ||
                    (id !== "" && tab.href.indexOf(id) > -1);
                let panel = document.getElementById(
                    tab.getAttribute("data-tab-target")
                );
                tab.classList.toggle("active", active);
                if (panel) {
                    panel.style.display = active ? "block" : "none";
                }
                if (active) {
                    for (let table of dependentTables) {
                        if (panel.contains(table.table)) {
                            table.heightFixed();
                        }
                    }
                }
            }
        };
        window.addEventListener("hashchange", function () {
            window.detailPageTabChangeTo(window.location.hash);
        });
        window.detailPageTabChangeTo(window.location.hash);
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => kitmapInit());
} else {
    kitmapInit();
}
